var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01758 19.248C4.48047 18.7109 4.50195 17.7979 5.00684 17.293L10.0449 12.2549L5.00684 7.22754C4.50195 6.72266 4.48047 5.80957 5.01758 5.27246C5.54395 4.73535 6.45703 4.75684 6.97266 5.26172L12 10.2998L17.0273 5.27246C17.5537 4.75684 18.4453 4.74609 18.9824 5.2832C19.5195 5.80957 19.5088 6.71191 18.9932 7.22754L13.9658 12.2549L18.9932 17.293C19.5088 17.8086 19.5195 18.7109 18.9824 19.2373C18.4453 19.7744 17.5537 19.7744 17.0273 19.248L12 14.2207L6.97266 19.2588C6.45703 19.7637 5.54395 19.7852 5.01758 19.248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.df56cc458055e80068022f18e0af3f34.svg";
export { ForwardRef as ReactComponent };